import React, { useContext } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import { StoreContext } from '../../context/StoreContext';
import Wrapper from '../elements/wrapper';
import { media } from '../helpers';
import CartItemImage from './cart-item-image';

import XIcon from '../../images/icons/x.inline.svg';
import PlusIcon from '../../images/icons/plus-circle.inline.svg';
import MinusIcon from '../../images/icons/minus-circle.inline.svg';

const CartContainer = styled(motion.div)`
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    z-index: 6000;
    height: 100vh;
    background-color: #fff;

    max-width: 100%;
    ${media.medium`max-width: 30%; border-left: 1px solid #000;`}

    .close-container {
        .btn-container {
            text-align: right;

            button {
                line-height: 1;
                padding: 15px;
                background-color: #fff;
                border: none;
                svg {
                    height: 35px;
                    width: 35px;
                }
            }
        }
    }

    .cart-wrapper {
        padding: 0 30px;
        .title-container {
        }

        .cart-items-container {
            max-height: 66vh;
            min-height: 60vh;
            overflow-y: scroll;
            .item-container {
                margin-bottom: 50px;
                > .inner-wrap {
                    display: flex;
                    align-items: center;
                    .image-container {
                        flex: 1;
                        img {
                            margin-bottom: 0px;
                        }
                    }
                    .content-container {
                        flex: 2;

                        .title {
                            h4 {
                                margin: 0 0 10px;
                                font-size: 1.1rem;
                            }
                        }

                        .variants-container {
                            margin-bottom: 10px;
                            p {
                                font-size: 0.8rem;
                                margin: 0 0;
                            }
                        }

                        .qty-container {
                            display: flex;
                            margin-bottom: 10px;
                            p {
                                margin: 0 10px 0 0;
                                font-size: 0.8rem;
                                font-weight: normal;
                            }
                            .qty-buttons {
                                display: flex;
                                align-items: center;
                                .btn-container {
                                    &:first-child {
                                        margin-right: 3px;
                                    }
                                    button {
                                        line-height: 1;
                                        background-color: #fff;
                                        padding: 0;
                                        border: none;
                                        &:hover {
                                            opacity: 0.7;
                                        }

                                        svg {
                                            height: 20px;
                                            width: 20px;
                                            position: relative;
                                            top: 3px;
                                            stroke-width: 1.5px;
                                        }
                                    }
                                }
                            }
                        }

                        .price-container {
                            display: flex;
                            align-items: baseline;
                            p {
                                font-weight: bold;
                                font-size: 0.8rem;
                                margin: 0;
                                line-height: 1;
                            }

                            .link-container {
                                margin-left: 10px;
                                button {
                                    background-color: #fff;
                                    border: none;
                                    text-decoration: underline;
                                    font-weight: bold;
                                    line-height: 1;
                                    font-size: 0.8rem;

                                    &:hover {
                                        opacity: 0.7;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .no-items-container {
            padding-top: 10px;
        }

        .cart-footer-container {
            border-top: 1px solid #000;
            padding-top: 20px;
            h3 {
                margin: 0;
                font-size: 1.3rem;
            }

            p {
                font-size: 0.8rem;
                margin: 0 0 15px;
            }
            .btn-container {
                a {
                    color: #fff;
                    background-color: #f74d33;
                    text-decoration: none;
                    font-weight: bold;
                    max-width: 180px;
                    padding: 15px 0;
                    display: inline-block;
                    width: 100%;
                    text-align: center;
                    font-size: 0.9rem;
                    line-height: 1;
                    border-radius: 5px;
                    border: 1px solid #f74d33;

                    &:hover {
                        color: #f74d33;
                        background-color: #fff;
                    }
                }
            }
        }
    }
`;

const Cart = () => {
    const {
        toggleCartClose,
        isCartOpen,
        checkout,
        updateQuantityInCart,
    } = useContext(StoreContext);

    const { lineItems } = checkout || {};

    return (
        <CartContainer
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
                open: { transform: 'translate3d(0%, 0, 0)' },
                collapsed: { transform: 'translate3d(100%, 0, 0)' },
            }}
            transition={{
                duration: 0.5,
            }}
        >
            <div className="close-container">
                <div className="btn-container">
                    <button onClick={() => toggleCartClose()}>
                        <XIcon />
                    </button>
                </div>
            </div>
            <Wrapper className="cart-wrapper">
                <div className="title-container">
                    <h2>Your Cart</h2>
                </div>

                <div className="cart-items-container">
                    {lineItems.length > 0 ? (
                        lineItems.map((item, index) => {
                            const {
                                title,
                                quantity,
                                variant,
                                customAttributes,
                            } = item;
                            let image = variant.image.src;
                            let { price, selectedOptions } = variant || {};
                            const isProductCustom = customAttributes.length > 0;
                            return (
                                <div key={index} className="item-container">
                                    <div className="inner-wrap">
                                        <CartItemImage
                                            title={title}
                                            image={image}
                                            isProductCustom={isProductCustom}
                                            colors={customAttributes}
                                        />
                                        <div className="content-container">
                                            <div className="inner-wrap">
                                                <div className="title">
                                                    <h4>{title}</h4>
                                                </div>
                                                <div className="variants-container">
                                                    {selectedOptions.map(
                                                        (option, index) => {
                                                            return (
                                                                <p key={index}>
                                                                    {
                                                                        option.name
                                                                    }
                                                                    :{' '}
                                                                    <span>
                                                                        {
                                                                            option.value
                                                                        }
                                                                    </span>
                                                                </p>
                                                            );
                                                        }
                                                    )}
                                                </div>
                                                <div className="qty-container">
                                                    <p className="qty">
                                                        Qty: {quantity}
                                                    </p>
                                                    <div className="qty-buttons">
                                                        <div className="btn-container">
                                                            <button
                                                                onClick={() =>
                                                                    updateQuantityInCart(
                                                                        item,
                                                                        quantity +
                                                                            1
                                                                    )
                                                                }
                                                            >
                                                                <PlusIcon />
                                                            </button>
                                                        </div>
                                                        <div className="btn-container">
                                                            <button
                                                                onClick={() =>
                                                                    updateQuantityInCart(
                                                                        item,
                                                                        quantity -
                                                                            1
                                                                    )
                                                                }
                                                            >
                                                                <MinusIcon />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="price-container">
                                                    <p className="price">
                                                        ${price}
                                                    </p>
                                                    <div className="link-container">
                                                        <button
                                                            onClick={() =>
                                                                updateQuantityInCart(
                                                                    item,
                                                                    0
                                                                )
                                                            }
                                                        >
                                                            Remove
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="no-items-container">
                            <h4>No items in your cart yet.</h4>
                        </div>
                    )}
                </div>
                <div className="cart-footer-container">
                    <h3>Total: ${checkout.subtotalPrice}</h3>
                    <p>Shipping, taxes and discounts calculated at checkout.</p>
                    <div className="btn-container">
                        <a href={checkout.webUrl}>Checkout</a>
                    </div>
                </div>
            </Wrapper>
        </CartContainer>
    );
};

export default Cart;
